// Local dev (npm start) runs on localhost — MSAL must redirect back to the
// origin the app is actually served from (the URI still has to be registered
// as a SPA redirect URI on the app registration).
const isLocalhost = ["localhost", "127.0.0.1"].includes(
	window.location.hostname
);
const redirectBase = isLocalhost
	? window.location.origin
	: "https://leadscrubapp.sfprocessing.com";

export const msalConfig = {
	auth: {
		clientId: "03dee493-f148-4b36-82a3-22d29a86b19b",
		authority:
			"https://login.microsoftonline.com/f9809d41-4885-4527-9a2b-b423ede40715",
		redirectUri: redirectBase,
		postLogoutRedirectUri: redirectBase,
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: false,
	},
};

export const loginRequest = {
	scopes: ["User.Read"], // or just []
};

// Scopes used to acquire an access token for the internal /import API
// (importer-spec §7). Env-driven so no new GUIDs are hardcoded here:
// set REACT_APP_IMPORT_API_SCOPE at build time (e.g. "api://<api-client-id>/access_as_user").
// Falls back to this SPA's own app-id URI, which is correct when the API is
// registered under the same app registration.
export const importApiRequest = {
	scopes: [
		process.env.REACT_APP_IMPORT_API_SCOPE ||
			`api://${msalConfig.auth.clientId}/access_as_user`,
	],
};
